import { httpClient } from '../../../httpClient';
import { IData } from '../../../models';
import { IApplyForm } from '../components/Apply';
import { ICareer } from './models';

export const getCareers = (): Promise<IData<ICareer>> => {
    return httpClient.get('careers');
};

export const applyPosition = (form: IApplyForm): Promise<void> => {
    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
        let itemVal = value;

        if (key === 'file') {
            itemVal = value[0];
        }

        formData.set(key, itemVal);
    });

    return httpClient.post('apply', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
